module.exports = __webpack_public_path__ + "img/24-800x800.d54b9515.jpg";